import styles from "./TextInput1.module.css";

const TextInput1 = () => {
  return (
    <div className={styles.textInput}>
      <div className={styles.placeholder}>Placeholder</div>
    </div>
  );
};

export default TextInput1;
